import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  DatePicker,
} from "antd";
import Container from "../../../../components/user/Container";
import FromInput from "../../../../components/user/from/Input";
import InputDateStartEnd from "../../../../components/user/from/InputDateStartEnd";
import { checkType } from "../../../../utils/checkType";
import { numberWithCommas } from "../../../../utils/number";
import { changeFormatdate, changeFormatFulldate } from "../../../../utils/formatdate";
import { approveStatus } from "../../../../utils/leave";
import { checkMoreThanLess } from "../../../../utils/formatdate";
import { alertMessage } from "../../../../utils/message";
import moment from "moment";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;

const newsDataProfile = "";

class Dashboard extends Component {
  state = {
    loading: true,
    loadingFullpage: true,
    dataTalbe: [],
    columns: [
      {
        // title: 'เลขที่เอกสาร',
        title: "เลขที่ข้อมูล",
        dataIndex: "studyLeaveNo",
        width: 150,
        // align:'center',
        render: (item, record, index) => <span>{item}</span>,
        // render: (item, record, index) => <span>{ item }</span>
      },
      // {
      //     title: 'ชื่อ-นามสกุล',
      //     dataIndex: 'employeeName',
      //     width:'200px',
      //    align:'center',
      //     render: (item, record, index) => <span>{ item }</span>
      // },
      {
        title: "สถานะการศึกษา",
        dataIndex: "leaveResultName",
        width: "200px",
        align: "center",
        render: (item, record, index) => <span>{item}</span>,
      },
      {
        title: "ระดับการศึกษา",
        dataIndex: "studyLeaveDegree",
        align: "center",
        width: "200px",
        render: (item, record, index) => (
          // <span>{ item  }</span>
          <span>{record.studyLeaveDetail[0].studyLeaveDegree}</span>
        ),
      },
      {
        title: "สถานบันการศึกษา",
        dataIndex: "studyLeaveAcademy",
        width: "150px",
        align: "center",
        render: (item, record, index) => (
          //  <span>{ item }</span>
          <span>{record.studyLeaveDetail[0].studyLeaveAcademy}</span>
        ),
      },
      // {
      //     title: 'วันที่เรื่มลา',
      //     dataIndex: 'leaveStartDate',
      //     width:'150px',
      //     render: (item, record, index) => <span>{ item ? changeFormatdate(item) : '-' }</span>
      // },
      {
        title: "วุฒิการศึกษา",
        dataIndex: "studyLeaveEducational",
        align: "center",
        // render: (item, record, index) => <span>{}</span>
        width: "130px",
        render: (item, record, index) => (
          // <span>{ item }</span>
          <span>{record.studyLeaveDetail[0].studyLeaveEducational}</span>
        ),
      },
      {
        title: "สาขาวิชา",
        dataIndex: "studyLeaveMajor",
        align: "center",
        width: "100px",
        render: (item, record, index) => (
          // <span>{ item ? approveStatus(item) : item }</span>
          <span>{record.studyLeaveDetail[0].studyLeaveMajor}</span>
        ),
      },
      {
        title: "ปีการศึกษา",
        align: "center",
        dataIndex: "studyLeaveStrategyYear",
        width: "150px",
        render: (item, record, index) => (
          // <span>{ item ? approveStatus(item) : item }</span>
          <span>{record.studyLeaveDetail[0].studyLeaveStrategyYear}</span>
        ),
      },
      {
        title: "แก้ไขล่าสุด",
        align: "center",
        dataIndex: "updatedAt",
        width: "150px",
        render: (item, record, index) => (
          // <span>{ item ? approveStatus(item) : item }</span>
          <span>{changeFormatFulldate(item)}</span>
        ),
      },
      {
        title: "จัดการ",
        dataIndex: "7",
        align: "center",
        width: 100,
        fixed: "right",
        render: (item, record, index) => {
          return (
            <>
              <Link
                to={{
                  pathname: record.studyLeaveRequestId
                    ? "/employeeRegistration/LeaveStudies/day/edit/" + record.studyLeaveRequestId
                    : "",
                }}
              >
                <Icon type="form" className="mr-2" style={{ color: "#000" }} />
                {/* { record.wdLeaveId } */}
              </Link>
              {/* {
									record.status == 'DRAFT' &&
									<Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField(record.wdHospitalId)} okText="ตกลง" cancelText="ยกเลิก">
										<Icon type="delete"/>
									</Popconfirm>
								} */}
            </>
          );
        },
      },
    ],
    pageData: {
      offset: 0,
      limit: 10,
    },
    pagination: {
      total: 10,
    },
    disabledDateStart: moment(new Date()).add(-1, "year"),
    endStartValues: moment(new Date()).add(1, "year"),
    valueStatus: "A",
    preLoadSubmit: false,
    formValue: null,
    dropdownLeaveType: [],
    currentPage: 1,
    loginPerson: [],
  };

  onChangeNameDivitions = (division, department) => {
    if (division && department) {
      return <p className="mb-0">{division + " / " + department}</p>;
    } else if (division) {
      return <p className="mb-0">{division}</p>;
    } else if (department) {
      return <p className="mb-0">{department}</p>;
    } else {
      return (
        <p className="mb-0" style={{ textAlign: "center" }}>
          {" "}
          -{" "}
        </p>
      );
    }
  };

  clearInput = async () => {
    await this.setState({
      formValue: null,
    });
    this.props.form.resetFields();
  };

  dropdownLeaveType = async () => {
    const { client, location, match } = this.props;
    const { empCode } = this.state;
    const { data, errors } = await client.query({
      query: Queries.dropdownLeaveType,
      variables: {
        // empCode
        isReqByEmp: true,
      },
    });

    console.log("data.dropdownLeaveType", data.dropdownLeaveType);

    if (data.dropdownLeaveType) {
      await this.setState({
        dropdownLeaveType: data.dropdownLeaveType,
      });
    }
  };

  fetchProfile = async () => {
    try {
      const { client } = this.props;
      const { data } = await client.query({
        query: Queries.fetchProfile,
      });

      await this.setState({
        loginPerson: data.fetchProfile,
      });
      // return data.fetchProfile

      console.log("FETCH PROFILE:", data.fetchProfile);
      console.log("FETCH emp:", data.fetchProfile.employeeCodes[0]);
    } catch (e) {}
  };

  fetchListStudyLeaveRequest = async () => {
    const { client, location, match } = this.props;
    const {
      offset,
      limit,
      disabledDateStart,
      endStartValues,
      pageData,
      loginPerson,
      ddStartYear,
      ddEndYear,
    } = this.state;
    console.log("loginPerson.employeeCodes[0]", loginPerson);

    console.log(
      "new Date().getFullYear()+543",
      (new Date().getFullYear() + 543).toString()
    );
    let searchKeyword = {
      departmentName: "",
      empCode: "",
      empName: "",
      studyLeaveNo: "",
      studyLeaveCourse: "",
      leaveResultName: "",
      leaveStatusName: "",
      studyLeaveStrategyYearFrom: ddStartYear,
      studyLeaveStrategyYearTo: ddEndYear,
     // studyLeaveStrategyYearTo: "2575",
    };

    await this.setState({
      preLoadSubmit: true,
      loading: true,
    });

    const { data, errors } = await client.query({
      query: Queries.fetchListStudyLeaveRequest,
      variables: {
        ...pageData,
        empCode: loginPerson.employeeCodes[0],
        viewMode: false,
        isAdmin: false,
        searchKeyword,
      },
    });

    console.log(
      "data.fetchListStudyLeaveRequest",
      data.fetchListStudyLeaveRequest
    );
    console.log("1213123", pageData);

    if (data.fetchListStudyLeaveRequest) {
      await this.setState({
        dataTalbe: data.fetchListStudyLeaveRequest.data,
        loading: false,
        preLoadSubmit: false,
        pagination: {
          total: data.fetchListStudyLeaveRequest.total,
        },
      });
    } else {
      await this.setState({
        loading: false,
        preLoadSubmit: false,
      });
    }
  };

  fetchListStudyLeaveRequestSearch = async (values) => {
    const { client } = this.props;
    const { pageData, loginPerson } = this.state;
    // const { offset ,limit, disabledDateStart, endStartValues } = this.state
    console.log("values", values);
    await this.setState({
      formValue: values,
      loading: true,
    });

    console.log("values", values);
    try {
      const { data, errors } = await client.query({
        query: Queries.fetchListStudyLeaveRequest,
        variables: {
          ...values,
          offset: 0,
          limit: 10,
          empCode: loginPerson.employeeCodes[0],
          viewMode: false,
        },
      });

      if (data.fetchListStudyLeaveRequest.data) {
        await this.setState({
          dataTalbe: data.fetchListStudyLeaveRequest.data,
          // preLoadOnsubmit: false,
          loading: false,
          pagination: {
            total: data.fetchListStudyLeaveRequest.total,
          },
          pageData: {
            offset: 0,
            limit: 10,
          },
          currentPage: 1,
        });
      } else {
        await this.setState({
          // dataTalbe: [],
          // preLoadOnsubmit: false,
          loading: false,
          pagination: {
            total: 0,
          },
          pageData: {
            offset: 0,
            limit: 10,
          },
          currentPage: 1,
          loading: false,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  fetchListStudyLeaveRequestSearchPagi = async (values) => {
    const { client } = this.props;
    const { pageData, loginPerson } = this.state;
    // const { offset ,limit, disabledDateStart, endStartValues } = this.state
    console.log("values searchPagi", values);
    await this.setState({
      formValue: values,
      loading: true,
    });

    console.log("values", values);
    try {
      const { data, errors } = await client.query({
        query: Queries.fetchListStudyLeaveRequest,
        variables: {
          ...values,
          ...pageData,
          empCode: loginPerson.employeeCodes[0],
          viewMode: false,
          isAdmin: false,
        },
      });

      if (data.fetchListStudyLeaveRequest.data) {
        await this.setState({
          dataTalbe: data.fetchListStudyLeaveRequest.data,
          // preLoadOnsubmit: false,
          loading: false,
          pagination: {
            total: data.fetchListStudyLeaveRequest.total,
          },
          // pageData: {
          //     offset: 0,
          //     limit: 10
          // },
          // currentPage: 1,
        });
      } else {
        await this.setState({
          // dataTalbe: [],
          // preLoadOnsubmit: false,
          loading: false,
          pagination: {
            total: 0,
          },
          pageData: {
            offset: 0,
            limit: 10,
          },
          // currentPage: 1, loading: false,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  paginationChange = async (e) => {
    const { formValue, empCode } = this.state;
    const { form, afterSubmit, client } = this.props;
    // await e.preventDefault()

    // console.log("pagination e",e)
    // console.log("pagination values",values)

    form.validateFields(async (err, values) => {
      console.log("values pagination", values);
      await this.setState({
        formValue: values,
      });

      console.log("paginationChange formvalue", values);

      if (!err) {
        try {
          let offset = 0;
          if (e.current === 1) {
            offset = 0;
          } else {
            offset = e.current - 1 + "0";
          }

          await this.setState({
            pageData: {
              offset: parseInt(offset),
              limit: 10,
            },
          });
          await this.setState({
            pageData: {
              offset: parseInt(offset),
              limit: 10,
            },
            currentPage: e.current,
          });

          // await this.fetchListPost()
          if (formValue) {
            console.log("paginationChange formvalue!!", values);
            await this.fetchListStudyLeaveRequestSearchPagi(values);
          } else {
            await this.fetchListStudyLeaveRequest();
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    });
  };

  fetchLeaveDocumentList = async () => {
    const { client, location, match } = this.props;
    const { offset, limit, disabledDateStart, endStartValues } = this.state;

    await this.setState({
      preLoadSubmit: true,
      loading: true,
    });

    const { data, errors } = await client.query({
      query: Queries.fetchLeaveDocumentList,
      variables: {
        // leaveStartDate:disabledDateStart,
        // leaveEndDate:endStartValues,
        // leaveTypeId:"A",
        approveStatus: "A",
      },
    });

    console.log("datasssss", data);

    if (data.fetchLeaveDocumentList) {
      await this.setState({
        dataTalbe: data.fetchLeaveDocumentList,
        loading: false,
        preLoadSubmit: false,
      });
    } else {
      await this.setState({
        loading: false,
        preLoadSubmit: false,
      });
    }
  };

  handleSubmit = async (e) => {
    const { form, afterSubmit, client } = this.props;
    const { telNo, otpToken, refCode, loginPerson } = this.state;

    await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("values", values);
      await this.setState({
        formValue: e,
        loading: true,
      });

      if (!err) {
        if (
          values.searchKeyword.studyLeaveStrategyYearFrom >
          values.searchKeyword.studyLeaveStrategyYearTo
        ) {
          alertMessage(
            "error",
            "กรุณาระบุปีงบประมาณเริ่มต้นน้อยกว่าปีงบประมาณสิ้นสุด"
          );
        } else if (
          values.searchKeyword.studyLeaveStrategyYearTo <
          values.searchKeyword.studyLeaveStrategyYearFrom
        ) {
          alertMessage(
            "error",
            "กรุณาระบุปีงบประมาณสิ้นสุดมากกว่าปีงบประมาณเริ่มต้น"
          );
        } else {
          try {
            const { data, errors } = await client.query({
              query: Queries.fetchListStudyLeaveRequest,
              variables: {
                ...values,
                offset: 0,
                limit: 10,
                empCode: loginPerson.employeeCodes[0],
                viewMode: false,
                isAdmin: false,
                values,
              },
            });

            console.log(
              "fetchListStudyLeaveRequest",
              data.fetchListStudyLeaveRequest
            );

            if (data.fetchListStudyLeaveRequest.data) {
              await this.setState({
                dataTalbe: data.fetchListStudyLeaveRequest.data,
                // preLoadOnsubmit: false,
                loading: false,
                pagination: {
                  total: data.fetchListStudyLeaveRequest.total,
                },
                pageData: {
                  offset: 0,
                  limit: 10,
                },
                currentPage: 1,
              });
            } else {
              await this.setState({
                // dataTalbe: [],
                // preLoadOnsubmit: false,
                loading: false,
                pagination: {
                  total: 0,
                },
                pageData: {
                  offset: 0,
                  limit: 10,
                },
                currentPage: 1,
                loading: false,
              });
            }
          } catch (error) {
            await this.setState({
              // dataTalbe: [],
              // preLoadOnsubmit: false,
              loading: false,
              pagination: {
                total: 0,
              },
              pageData: {
                offset: 0,
                limit: 10,
              },
              currentPage: 1,
              loading: false,
            });
            console.log("error", error);
          }
        }
      }
    });
  };

  delectField = async (wdHospitalId) => {
    const { form, client } = this.props;
    const { formValue } = this.state;
    console.log(formValue);
    try {
      const { data, errors } = await client.mutate({
        mutation: Mutations.destroyWDHospital,
        variables: {
          wdHospitalId,
        },
      });
      // console.log(data)
      if (data) {
        message.success("ทำการลบรายการขอเบิก");
        if (formValue) {
          await this.handleSubmit(formValue);
          // await this.fetchLeaveDocumentList(formValue)
        } else {
          this.fetchLeaveDocumentList();
        }
      }
    } catch (error) {
      this.setState({
        preLoadOnsubmit: false,
      });
      console.log("error", error);
    }
  };

  clearInput = async () => {
    await this.setState({
      formValue: null,
      disabledDateStart: moment(new Date()).add(-1, "year"),
      endStartValues: moment(new Date()).add(1, "year"),
    });
    this.props.form.resetFields();
  };

  onChangeValueDateStart = async (e) => {
    const { endStartValues } = this.state;

    await this.setState({
      disabledDateStart: moment(e),
    });
    console.log("endStartValues", endStartValues);

    let checkDatemore = checkMoreThanLess(e, endStartValues);

    if (checkDatemore) {
      await this.props.form.setFieldsValue({
        leaveEndDate: checkDatemore,
      });

      await this.setState({
        endStartValues: checkDatemore,
      });
    }
  };

  onChangeValueDateEnd = async (e) => {
    await this.setState({
      endStartValues: moment(e),
    });
  };

  onChangeStatus = async (e) => {
    // this.form.resetFields('endDate')
    // await this.setState({
    // 	 disabledDateStart: moment(e),
    // })
  };

  disabledDate = (current) => {
    const { disabledDateStart } = this.state;
    return current && current < disabledDateStart;
  };

  fetchDropDownMasterData = async (dropDownType) => {
    const { client, location, match } = this.props;
    const { empCode, loadingFullpage } = this.state;

    let dropDownRetrue = [];
    try {
      const { data, errors } = await client.query({
        query: Queries.fetchDropDownMasterData,
        variables: {
          dropDownType,
        },
      });

      await data.fetchDropDownMasterData.map((values, keys) => {
        dropDownRetrue.push({
          value: values.id,
          label: values.label,
        });
      });

      await this.setState({
        ["dropDownType" + dropDownType]: dropDownRetrue,
        loadingFullpage: false,
      });

      if (dropDownType == "leaveYear") {
        if (dropDownRetrue && dropDownRetrue?.length > 0) {
          await this.setState({
            ddStartYear: dropDownRetrue[0].value,
            ddEndYear: dropDownRetrue[dropDownRetrue?.length - 1].value,
            startYear: dropDownRetrue[0].value,
            endYear: dropDownRetrue[dropDownRetrue?.length - 1].value,
          });
        }
      }

      // return dropDownRetrue;
    } catch (error) {
      console.log(error);
      return dropDownRetrue;
    }
  };
  FormDropDown = (
    formInput = {
      name: null,
      label: null,
      required: false,
      requiredLabel: null,
      onChangeInput: false,
      values: null,
      disabled: false,
      dropdownList: [],
      placeholder: "",
    }
  ) => {
    return (
      <>
        <Row gutter={0} type="flex" justify="left" align="top">
          <Col xs={24} md={24}>
            <Form.Item
              name={formInput.name}
              label={formInput.label}
              initialValue={formInput.values ? formInput.values : null}
              rules={[
                {
                  required: formInput.required,
                  message: "กรุณาเลือก " + formInput.label,
                },
              ]}
            >
              <Select
                showSearch
                style={{ width: "100%", borderRadius: "2px 2px 0 0;" }}
                placeholder={formInput.placeholder}
                optionFilterProp="children"
                className="input-select-border-create"
                onChange={(e) =>
                  formInput.onChangeInput ? formInput.onChangeInput(e) : ""
                }
                disabled={formInput.disabled}
              >
                <Option value="">ทั้งหมด</Option>
                {formInput.dropdownList &&
                  formInput.dropdownList.map((values, keys) => (
                    <Option value={values.value} key={keys}>
                      {values.label}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  };

  onChangeValueYearStart = async (e) => {
    const { endYear } = this.state;
    console.log("e onChangeValueYearStart", e);
    console.log("e onChangeValueYearStart endYear", endYear);

    if (e > endYear) {
      alertMessage(
        "error",
        "กรุณาระบุปีงบประมาณเริ่มต้นน้อยกว่าปีงบประมาณสิ้นสุด"
      );

      this.props.form.setFieldsValue({
        searchKeyword: {
          studyLeaveStrategyYearFrom: null,
        },
      });
    } else {
      this.setState({
        startYear: e,
      });
    }
  };

  onChangeValueYearEnd = async (e) => {
    const { startYear } = this.state;
    console.log("e onChangeValueYearEnd", e);
    console.log("e onChangeValueYearEnd startYear", startYear);

    if (e < startYear) {
      console.log("e onChangeValueYearEnd Error startYear", startYear);
      alertMessage(
        "error",
        "กรุณาระบุปีงบประมาณสิ้นสุดมากกว่าปีงบประมาณเริ่มต้น"
      );

      this.props.form.setFieldsValue({
        searchKeyword: {
          studyLeaveStrategyYearTo: null,
        },
      });
    } else {
      this.setState({
        endYear: e,
      });
    }
  };

  async componentDidMount() {
    await this.fetchProfile();
    await this.fetchDropDownMasterData("course");
    await this.fetchDropDownMasterData("leaveResult");
    await this.fetchDropDownMasterData("leaveYear");
    await this.fetchDropDownMasterData("studyStatus");
    await this.fetchListStudyLeaveRequest();
    // await this.dropdownLeaveType()
  }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log("sssdataTalbe", dataTalbe);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {/* <Breadcrumb.Item> */}
          <span style={{ fontSize: "18px" }}>
            ทะเบียนประวัติบุคลากร / การศึกษา/ฝึกอบรมเฉพาะทาง{" "}
          </span>
          {/* </Breadcrumb.Item> */}
        </div>
        <Spin spinning={loadingFullpage} delay={0}>
          <div className="card-container" id="page-profile">
            <div className="px-5 py-1 card-bg-green">
              <Form onSubmit={this.handleSubmit}>
                <Row
                  gutter={16}
                  type="flex"
                  justify="left"
                  align="top"
                  className="box-color-white mb-0"
                >
                  <Col xs={24} md={24} className="pt-2  mb-3">
                    <strong className="color-red">ค้นหา</strong>
                  </Col>
                  <Col xs={24} md={12} className="pt-2">
                    <Row
                      gutter={16}
                      type="flex"
                      justify="left"
                      align="top"
                      className=""
                    >
                      <Col xs={4} md={5} className="pt-1">
                        <b>เลขที่ข้อมูล:</b>
                      </Col>
                      <Col xs={20} md={14} className="">
                        <Form.Item style={{ marginBottom: "0px" }}>
                          {getFieldDecorator(`searchKeyword.studyLeaveNo`, {
                            initialValue: "",
                          })(
                            <Input
                              disabled={false}
                              mode={"title"}
                              //placeholder={"รหัส"}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={20} md={12} className="pt-2">
                    <Row
                      gutter={16}
                      type="flex"
                      justify="left"
                      align="top"
                      classNam="pt-2"
                    >
                      <Col xs={4} md={5} className="pt-1">
                        <b>หลักสูตร:</b>
                      </Col>
                      <Col xs={20} md={14} className="pt-0">
                        <Form.Item style={{ marginBottom: "0px" }}>
                          {getFieldDecorator(`searchKeyword.studyLeaveCourse`, {
                            initialValue: "",
                          })(
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                                borderRadius: "2px 2px 0 0;",
                              }}
                              placeholder="กรุณาเลือก หลักสูตร"
                              optionFilterProp="children"
                              className="input-select-border-create"
                              disabled={false}
                            >
                              <Option value="">ทั้งหมด</Option>
                              {this.state.dropDownTypecourse &&
                                this.state.dropDownTypecourse.map(
                                  (values, keys) => (
                                    <Option value={values.value} key={keys}>
                                      {values.label}
                                    </Option>
                                  )
                                )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} md={12} className="pt-2">
                    <Row
                      gutter={16}
                      type="flex"
                      justify="left"
                      align="top"
                      classNam="pt-2"
                    >
                      <Col xs={4} md={5} className="pt-2">
                        <b>สถานะการศึกษา:</b>
                      </Col>
                      <Col xs={20} md={14} className="pt-0">
                        <Form.Item>
                          {getFieldDecorator(`searchKeyword.leaveResultName`, {
                            initialValue: "",
                          })(
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                                borderRadius: "2px 2px 0 0;",
                              }}
                              placeholder="กรุณาเลือก สถานะการศึกษา"
                              optionFilterProp="children"
                              className="input-select-border-create"
                              disabled={false}
                            >
                              <Option value="">ทั้งหมด</Option>
                              {this.state.dropDownTypeleaveResult &&
                                this.state.dropDownTypeleaveResult.map(
                                  (values, keys) => (
                                    <Option value={values.value} key={keys}>
                                      {values.label}
                                    </Option>
                                  )
                                )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} md={12} className="pt-2">
                    <Row
                      gutter={16}
                      type="flex"
                      justify="left"
                      align="top"
                      classNam="pt-2"
                    >
                      <Col xs={4} md={5} className="pt-2">
                        <b>ปีงบประมาณ:</b>
                      </Col>
                      <Col xs={9} md={6} className=" ">
                        <Form.Item>
                          {getFieldDecorator(
                            `searchKeyword.studyLeaveStrategyYearFrom`,
                            {
                              initialValue: ddStartYear,
                            }
                          )(
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                                borderRadius: "2px 2px 0 0;",
                              }}
                              placeholder="กรุณาเลือก ปี"
                              optionFilterProp="children"
                              className="input-select-border-create"
                              disabled={false}
                              // onChange={(e) =>
                              //   this.onChangeValueYearStart(e)
                              // }
                            >
                              {this.state.dropDownTypeleaveYear &&
                                this.state.dropDownTypeleaveYear.map(
                                  (values, keys) => (
                                    <Option value={values.value} key={keys}>
                                      {values.label}
                                    </Option>
                                  )
                                )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col xs={2} md={2} className="pt-2">
                        <b>ถึง:</b>
                      </Col>
                      <Col xs={9} md={6} className=" ">
                        <Form.Item>
                          {getFieldDecorator(
                            `searchKeyword.studyLeaveStrategyYearTo`,
                            {
                              initialValue: ddEndYear,
                            }
                          )(
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                                borderRadius: "2px 2px 0 0;",
                              }}
                              placeholder="กรุณาเลือก ปี"
                              optionFilterProp="children"
                              className="input-select-border-create"
                              disabled={false}
                              // onChange={(e) =>
                              //   this.onChangeValueYearEnd(e)
                              // }
                            >
                              {this.state.dropDownTypeleaveYear &&
                                this.state.dropDownTypeleaveYear.map(
                                  (values, keys) => (
                                    <Option value={values.value} key={keys}>
                                      {values.label}
                                    </Option>
                                  )
                                )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={24} md={24} align={"right"}>
                    <Button
                      type="primary"
                      className="mx-2 btn-white-red"
                      htmlType="submit"
                      onClick={this.clearInput}
                    >
                      ล้างค่า
                    </Button>
                    <Button
                      type="primary"
                      id="btn-onsearch"
                      className="ml-2 color-white"
                      htmlType="submit"
                      disabled={preLoadSubmit}
                    >
                      ค้นหา
                    </Button>
                    {preLoadSubmit && <Spin size="small" />}
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="px-5 py-1 card-bg-green">
              <Row
                gutter={16}
                type="flex"
                justify="left"
                align="top"
                className="box-color-white"
              >
                <Col xs={24} md={12} className="pt-2 mb-3">
                  <strong className="color-red">รายการศึกษา/ฝึกอบรมเฉพาะทาง</strong>
                </Col>
                <Col xs={24} md={24} align={"center"}>
                  {
                    <Table
                      locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                      dataSource={dataTalbe}
                      columns={columns}
                      loading={loading}
                      // scroll={{ x: 'max-content' }}
                      // pagination={pagination}
                      // pagination={{ pageSize: dataTalbe.length }}
                      scroll={{ x: "max-content", y: "550px" }}
                      pagination={{
                        total: pagination.total,
                        current: currentPage,
                        showSizeChanger: false,
                      }}
                      onChange={this.paginationChange}
                      // onChange={this.paginationChange}
                      // rowCount={dataTalbe.length}
                    />
                  }
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
      </Container>
    );
  }
}

Dashboard.defaultProps = {
  autoFocus: false,
};

Dashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedDashboard = Form.create()(Dashboard);

export default withApollo(WrappedDashboard);
